"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEAufbauId = void 0;
/**
 * Gives information about how the AE is used or which single AE it consists of.
 */
var AEAufbauId;
(function (AEAufbauId) {
    /** (first) single AE */
    AEAufbauId[AEAufbauId["singleFirst"] = 1] = "singleFirst";
    /** (second) single AE */
    AEAufbauId[AEAufbauId["singleSecond"] = 2] = "singleSecond";
    /** one ae pair consisting of two __identical__ single AEs */
    AEAufbauId[AEAufbauId["pairIdentical"] = 11] = "pairIdentical";
    /** one ae pair consisting of two __different__ single AEs */
    AEAufbauId[AEAufbauId["pairDifferent"] = 12] = "pairDifferent";
})(AEAufbauId = exports.AEAufbauId || (exports.AEAufbauId = {}));
//# sourceMappingURL=AEAufbauId.js.map